export const getKeycloakRealm = () =>
  getRequiredEnvVariable('VITE_KEYCLOAK_REALM', 'KEYCLOAK_REALM')

export const getKeycloakUrl = () => getRequiredEnvVariable('VITE_KEYCLOAK_URL', 'KEYCLOAK_URL')

export const getSentryDsn = () => getRequiredEnvVariable('VITE_SENTRY_DSN', 'SENTRY_DSN')

export const getSentryEnvironment = () =>
  getRequiredEnvVariable('VITE_SENTRY_ENVIRONMENT', 'SENTRY_ENVIRONMENT')

export const getKeycloakClientId = () =>
  getRequiredEnvVariable('VITE_KEYCLOAK_CLIENT_ID', 'KEYCLOAK_CLIENT_ID')

export const isMaintenanceModeOn = () =>
  getRequiredEnvVariable('VITE_MAINTENANCE_MODE', 'MAINTENANCE_MODE') === 'true'

export const getMaintenanceModeBypassCode = () =>
  getRequiredEnvVariable('VITE_MAINTENANCE_MODE_BYPASS_CODE', 'MAINTENANCE_MODE_BYPASS_CODE')

export const getRefreshIntervalIncomingRequests = () =>
  secondsStringToMs(
    getRequiredEnvVariable(
      'VITE_REFRESH_INTERVAL_INCOMING_REQUESTS',
      'REFRESH_INTERVAL_INCOMING_REQUESTS',
      '10'
    )
  )

export const getRefreshIntervalOutgoingRequests = () =>
  secondsStringToMs(
    getRequiredEnvVariable(
      'VITE_REFRESH_INTERVAL_OUTGOING_REQUESTS',
      'REFRESH_INTERVAL_OUTGOING_REQUESTS',
      '60'
    )
  )

export const getRefreshIntervalCases = () =>
  secondsStringToMs(
    getRequiredEnvVariable('VITE_REFRESH_INTERVAL_CASES', 'REFRESH_INTERVAL_CASES', '60')
  )

export const getRefreshIntervalPatientDetails = () =>
  secondsStringToMs(
    getRequiredEnvVariable(
      'VITE_REFRESH_INTERVAL_PATIENT_DETAILS',
      'REFRESH_INTERVAL_PATIENT_DETAILS',
      '60'
    )
  )

export const getRefreshIntervalVitalSigns = () =>
  secondsStringToMs(
    getRequiredEnvVariable(
      'VITE_REFRESH_INTERVAL_VITAL_SIGNS',
      'REFRESH_INTERVAL_VITAL_SIGNS',
      '30'
    )
  )

export const getRefreshIntervalNotificationCenter = () =>
  secondsStringToMs(
    getRequiredEnvVariable(
      'VITE_REFRESH_INTERVAL_NOTIFICATION_CENTER',
      'REFRESH_INTERVAL_NOTIFICATION_CENTER',
      '10'
    )
  )

export const getAkBaseUrl = () => getRequiredEnvVariable('VITE_AK_BASE_URL', 'AK_BASE_URL')

export const getRefreshIntervalCheckLoginStatus = () =>
  secondsStringToMs(
    getRequiredEnvVariable(
      'VITE_REFRESH_INTERVAL_CHECK_LOGIN_STATUS',
      'REFRESH_INTERVAL_CHECK_LOGIN_STATUS',
      '30'
    )
  )

export const getRefreshIntervalShiftDuration = () =>
  secondsStringToMs(
    getRequiredEnvVariable(
      'VITE_REFRESH_INTERVAL_SHIFT_DURATION',
      'REFRESH_INTERVAL_SHIFT_DURATION',
      '30'
    )
  )

export const getConsultationActivityHeartbeatInterval = () =>
  secondsStringToMs(
    getRequiredEnvVariable(
      'VITE_CONSULTATION_ACTIVITY_HEARTBEAT_INTERVAL',
      'VITE_CONSULTATION_ACTIVITY_HEARTBEAT_INTERVAL',
      '10'
    )
  )

export const getRequiredEdsLimitationsVersion = () =>
  getRequiredEnvVariable(
    'VITE_REQUIRED_EDS_LIMITATIONS_VERSION',
    'REQUIRED_EDS_LIMITATIONS_VERSION'
  )

export const getRequiredEdsLimitationsScope = () =>
  getRequiredEnvVariable('VITE_REQUIRED_EDS_LIMITATIONS_SCOPE', 'REQUIRED_EDS_LIMITATIONS_SCOPE')

export const getRequiredAkiLimitationsVersion = () =>
  getRequiredEnvVariable(
    'VITE_REQUIRED_AKI_LIMITATIONS_VERSION',
    'REQUIRED_AKI_LIMITATIONS_VERSION'
  )

export const getRequiredAkiLimitationsScope = () =>
  getRequiredEnvVariable('VITE_REQUIRED_AKI_LIMITATIONS_SCOPE', 'REQUIRED_AKI_LIMITATIONS_SCOPE')

function secondsStringToMs(seconds: string): number {
  return parseInt(seconds, 10) * 1000
}

function getRequiredEnvVariable(viteKey: string, envKey: string, fallback?: string): string {
  const localValue = import.meta.env?.[viteKey]
  if (localValue !== undefined) {
    return localValue
  }
  if (typeof env !== 'undefined' && env[envKey] !== undefined) {
    return env[envKey]
  }
  if (fallback !== undefined) {
    return fallback
  }
  throw new Error(`Missing required environment variable: ${viteKey} / ${envKey}`)
}
